'use strict';

var giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    validator = require('../validator'),
    tealium = require('../../../../int_tealium/cartridge/js/tealium/tealium'),
    progress = require('../progress'),
    imagesLoaded = require('imagesloaded'),
    ajax = require('../ajax'),
    internationalshipping = require('../internationalshipping'),
    minicart = require('../minicart')

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $('#edit-address-form');
    $form.find('input[name="format"]').remove();
    tooltip.init();
    $form.off('click', '.apply-button').on('click', '.apply-button', function (e) {
        var clickOrKey = window.lastClickOrKey;
        e.preventDefault();
        if (!$form.valid()) {
            var errorMsg = '';
            $('.form-row.error-handle').find('.label-text').each(function (index) {
                appendErrorInLabel($(this).closest('.form-row').find('input'));
                errorMsg = $('.form-row.error-handle').length - 1 == index && errorMsg != '' ? (errorMsg + ' and ' + $(this).text()) : (errorMsg == '' ? $(this).text() : errorMsg + ', ' + $(this).text());
            });
            $form.find('.form-validation-error-msg').text('').removeAttr('aria-live');
            if (!$('.form-row.error-handle input, .form-row.error-handle select').val().length) {
            	$form.find('.form-validation-error-msg').text('Error: Please enter ' + errorMsg).show().attr('aria-live','assertive');
            }
            $form.find('.form-validation-error-msg').addClass('error');
            $('.form-row.error-handle').first().find('input').focus().addClass(clickOrKey === 'key' ? 'focus-outline' : '');
            return false;
        }
        var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
        var applyName = $form.find('.apply-button').attr('name');
        var form = new FormData(document.querySelector('#edit-address-form'));
        form.append(applyName, 'x');
        var options = {
            url: url,
            data: form,
            method: 'POST',
            callback: function (data) {
                if (typeof (data) !== 'string') {
                    if (data.success) {
                        dialog.close();
                        page.refresh();
                    } else if (data.error) {
                        page.redirect(Urls.csrffailed);
                    } else if (data.message) {
                        $form.find('.form-validation-error-msg').addClass('error').text('Error: '+data.message).show().attr('aria-live', 'assertive');
                        return false;
                    }
                } else {
                    $('#dialog-container').html(data);
                    account.init();
                    tooltip.init();
                }
            }
        };
        ajax.fetchData(options);
    })
    .on('click', '.cancel-button, .close-button', function (e) {
        e.preventDefault();
        dialog.close();
    })
    .on('click', '[name$="_profile_address_makeDefault"]', function (e) {
        if($(this).prop('checked')){
            $(this).val(true);
            $(this).prop('checked',true);
        }else{
            $(this).val(false);
            $(this).prop('checked',false);
        }
    });

}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder () {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .click(function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
}

/**
 * @private
 * @function
 * @description Fills the catherine reward graphs.
 */
function fillRewardGraphs () {
    $(window).on('load resize', function () {
		if($('.ca-rewards').length){
            var rewardDollarAmount = parseInt($('input[name="reward-dollar-amount"]').val(), 10);
            var pointsToNextReward = parseInt($('input[name="points-to-next-reward"]').val(), 10);
            var barWidth = $('.tier-filler-bar').width();
            var filledBarWidth = 0;
            var circleFill = 0;

            if(rewardDollarAmount < 350){
                filledBarWidth += (rewardDollarAmount/350)*(barWidth/3);
            }
            else if(rewardDollarAmount < 800){
                filledBarWidth += ((rewardDollarAmount-349)/450)*(barWidth/3) + barWidth/3;
            }
            else if(rewardDollarAmount < 1600){
                filledBarWidth += ((rewardDollarAmount-799)/800)*(barWidth/3) + 2*(barWidth/3);
            }
            else{
                filledBarWidth = barWidth;
            }

            $('.empty-tier-bar').css('width', (barWidth-filledBarWidth)+'px');
            $('.filled-tier-bar').css('width', filledBarWidth+'px');

            if(pointsToNextReward < 3000){
                circleFill = (pointsToNextReward/3000)*180;
            }
            else{
                circleFill = 180; 
            }
            $('.circle-wrap .circle .fill, .circle-wrap .circle .mask.full').css('transform','rotate('+circleFill+'deg)');
        }
    });
    
    $(document).on('click', '.pending-points-link', function (e) {
        e.preventDefault();
        var pendingPointsOverlay = $('#pending-points-overlay').html();
        dialog.open({
            html: pendingPointsOverlay,
            options: {
                width: 365,
                dialogClass: 'pending-points-overlay'
            }
        });
    });


    $(document).on('click', '.ca-reward-tnc-link', function (e) {
        e.preventDefault();
        var legalCopyOverlay = $('#legal-copy-overlay').html();
        dialog.open({
            html: legalCopyOverlay,
            options: {
                dialogClass: 'legal-copy-overlay'
            }
        });
    });

    $(document).on('click', '.ca-reward-enroll-cta', function(){
        var obj = {
            event_name: "rewards_opt_in",
            location: "My Account"
        };
        tealium.triggerEvent(obj);
    });
}

/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) { return; }

    var buttonClasses = '.address-edit, .address-create';

    addresses.off('click', buttonClasses)
    .on('click', buttonClasses, function (e) {
        var target = $(e.target);
        var address_obj = {
            edit_create_Address:$(buttonClasses),
            edit_form:$('#edit-address-form'),
            error_message:$('.form-validation-error-msg'),
            second_list_element:$('.list-sec-address-form'),
            edit_address:$('.editaddress'),
            address_list:$('.address-list-sec'),
            save_address:$('.saveaddress'),
            save_addressexit:$('.save-addressexist'),
            save_and_exit_address:$('.saveaddress,.save-addressexist'),
            action_name:$('.actionname'),
            address_form:$('.address-form'),
            default_input:$('.makeDefault input')
        };
        var addressFunctions = {
            validateAddress:function(){
                address_obj.edit_form.validate().resetForm();
                address_obj.error_message.text('').removeClass('error');
            },
            createAddress:function(){

               if (address_obj.default_input.is(':checked')) {
                address_obj.default_input.trigger('click');
             }
             $('#edit-address-form .form-row input,#edit-address-form form-row select').val('');
             address_obj.edit_form.find('.form-row').removeClass('show-text');
             address_obj.edit_form.find('.form-row ').find('label').removeClass('input-focus');
             if(address_obj.address_list.length>0){
                 $('.editaddress,.saveaddress').hide();
                 address_obj.save_addressexit.show();
                 if( address_obj.second_list_element.find('.address-form-block').length==0){
                      address_obj.second_list_element.append($('.address-form-block'));
                      address_obj.second_list_element.prev('.address-list-sec').hide();
                 }
                 if(target.closest('.addressinfo').find('.column-2').find('.address-list-sec').length>0){
                     if($(window).width() > 767) {
                          address_obj.second_list_element.insertBefore(
                              target.closest('.addressinfo').find('.column-2').find('.address-list-sec').first()
                            );
                     } else {
                          address_obj.second_list_element.insertBefore(
                              target.closest('.addressinfo').find('.column-1').find('.address-list-sec').first()
                            );
                     }
                 }else{
                     if($(window).width() > 735 || $(window).height() > 852  ) {
                     target.closest('.addressinfo').find('.column-2').prepend( address_obj.second_list_element);
                     }else{
                     target.closest('.addressinfo').find('.column-1').prepend( address_obj.second_list_element);

                     }
                 }
             }else{
                 $('.editaddress,.save-addressexist').hide();
                 $('.saveaddress').show();
                 if($(window).width() > 767) {
                      address_obj.second_list_element.find('.address-form-block').insertBefore($(this).closest('.addressinfo').find('.column-2').find('.address-list-sec').first());
                 } else {
                      address_obj.second_list_element.find('.address-form-block').insertBefore($(this).closest('.addressinfo').find('.column-1').find('.address-list-sec').first());
                 }

             }
            },
            editAddress:function(){

               address_obj.save_and_exit_address.hide();
               address_obj.edit_address.show();
               if( address_obj.second_list_element.find('.address-form-block').length==0){
                    address_obj.second_list_element.append($('.address-form-block'));
                    address_obj.second_list_element.prev('.address-list-sec').hide();
               }
                address_obj.second_list_element.insertAfter(target.closest('.address-list-sec'));
                address_obj.second_list_element.prev('.address-list-sec').hide();
               if (target.hasClass('default-address')) {
                   if (!address_obj.default_input.is(':checked')) {
                       address_obj.default_input.trigger('click');
                   }
               }
            },
            resetAddress:function(){
                address_obj.edit_create_Address.removeClass('no-click');
                target.addClass('no-click');
                address_obj.edit_form.trigger('reset');
                address_obj.second_list_element.hide().prev('.address-list-sec').show();
            },
            updateAddress:function(){

               address_obj.second_list_element.show();

               var $address2 = $('.address-form-block .form-row.address2');
               if(!$address2.find('input').val())
                   $address2.removeClass('show-text');
               util.updateInputFields();
               $('html,body').animate({
                   scrollTop:address_obj.second_list_element.offset().top - 75
               });

               address_obj.action_name.attr('name',$('.add-name').val());

               if (target.hasClass('address-edit')) {
                address_obj.address_form.removeClass('hide');
                   var selectedAddress = target.data('address');
                   var $form = address_obj.edit_form;
                   if (selectedAddress) {
                       util.fillAddressFields(selectedAddress, $form);
                       util.updateselect();
                   }
                   address_obj.action_name.attr('name',$('.edit-name').val());

               } else {
                address_obj.address_form.toggleClass('hide');

               }

               address_obj.edit_form.find('input, select, .selected-option').blur();
               address_obj.edit_form.find('.form-row').removeClass('error-handle');
               address_obj.edit_form.find('span.error').remove();
               util.inputfocusEvent();
            }
        };
        var unClickable = target.hasClass('no-click');
        //end of variables
        addressFunctions.validateAddress();
        if(!unClickable) {
            addressFunctions.resetAddress();
            //if edit was clicked
            if(target.hasClass('address-edit')){
                addressFunctions.editAddress();
            }else if(target.hasClass('address-create')){
                addressFunctions.createAddress();
            } //end edit / create
            addressFunctions.updateAddress();
        }
       // end of condition unClickable

    }) // end of '.address-edit, .address-create' click-function

    .on('click', '.delete', function (e) {
        e.preventDefault();
        $(this).closest('.address-list-sec').find('.delete-content').slideDown();
    }).on('keyup','.delete', function(e){
        if(e.keyCode === 13){
            e.preventDefault();
            util.trapFocus($($(this).closest('.address-list-sec').find('.delete-content')), () => {
                $(this).closest('.address-list-sec').find('.delete-content').slideUp();
                $(this).closest('.address-tile').find('button.address-delete').focus().addClass('focus-outline');
            })
        }
    }).on('click','.cancel-address',function(e){
        e.preventDefault();
        $('.address-form').addClass('hide');
        $('.list-sec-address-form').hide();
        $('.list-sec-address-form').prev('.address-list-sec').show();
        $('.list-sec-address-form').insertAfter($(this).closest('.addressinfo').find('.address-details').first());
        $('.address-edit, .address-create').removeClass('no-click');
        $('html,body').animate({
          scrollTop: $('#addresses').offset().top - 50
        });
    }).on('keyup',buttonClasses, function(e){
        if(e.keyCode === 13){
            e.preventDefault();
            $('.address-form-block').find(':focusable').first().focus().addClass('focus-outline');
        }
    });

}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
	if($('.payment-form').is(':visible')) {
        $('.add-card').addClass('active');
        $('.payment-form').find('#CreditCardForm').attr('aria-expanded','true');
	}
    $('.add-card').on('click keydown', function (e) {
        if(e.type == 'keydown' && e.keyCode != 13){
            return true;
        }
        $('input[name$="_newcreditcard_makeDefault"]').prop('checked', true);
        $('input[name$="_newcreditcard_makeDefault"]').val('true');
        var $form = $('.payment-form').find('#CreditCardForm');
        $form.find('.payment-fields .form-row input').val('').triggerHandler('blur');
        $form.find('.payment-fields .form-row').removeClass('error-handle');
        $form.find('.payment-fields .form-row').find('.error,.server-error').remove('span');
    	$form.find('.payment-fields .form-row select').val('').triggerHandler('change');
    	$form.find('.payment-fields').find(".form-row").removeClass('show-text');
        $form.find('.payment-fields').find(".form-row").find("label").removeClass("input-focus");
        $form.attr('aria-expanded','true');
        $('.payment-form').slideDown('slow');
        $(this).addClass('active');        
        if(e.keyCode == 13){
            setTimeout(function(){
                $('.add-card').focus().addClass('focus-outline');
            }, 500);            
        }
    });

    $('.card-actions').on('click keydown','.cancel-button',function(e){
        if(e.type == 'keydown' && e.keyCode != 13){
            return true;
        }
        e.preventDefault();
        $('.payment-form').slideUp('slow');
        if ($('.payment-form span.error').text() != "") {
        	$('.payment-form').find('span.error').addClass('hide');
        }
        var $form = $('.payment-form').find('#CreditCardForm');
        $form.attr('aria-expanded','false');
        if(e.keyCode == 13 && $('.delete-card .delete').length){
        	$('.delete-card .delete').eq(0).focus().addClass('focus-outline');
        }
        $('.add-card').removeClass('active');
    });

    $('#CreditCardForm').on('submit',function(e){
        var isTriggerEnter = window.lastClickOrKey === 'key' ? true : false ; 
        $form = $(this);
        if(!$form.valid()) {
            e.preventDefault();
            var $firstErroField = $form.find(":input.error").first();

            if($firstErroField.hasClass("input-select")) {
                $firstErroField.closest('.custom-select').addClass('current_item');
            }

            $firstErroField.trigger('focus');
            
            if(isTriggerEnter){        
               setTimeout(() => {
                    $firstErroField.addClass('focus-outline');
                    if($firstErroField.hasClass("input-select")) {
                        $firstErroField.closest('.custom-select').addClass('focus-outline').removeClass('current_item');
                    }
               }, 0);
            }
        	return false;
        }
    });

    var paymentList = $('.payment-list');
    if (paymentList.length === 0) { return; }

    $('.payment-list .showall').on('click',function(e){
        e.preventDefault();
        $(this).hide();
        $('.payment-list .hidedetails').show();
    });

    //util.setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));

    $('body').off('click','.cardinfo').on('click','.cardinfo', function(e) {
        $('.checkstatus').hide();
        if ($(e.target).closest('.delete-card').length == 0 && $(e.target).closest('a.plcc-tooltip').length == 0) {
            $(this).find('.checkstatus').toggle();
        }
    });

    if($("select[name $='_creditcards_newcreditcard_type']").find('option:selected').attr("plccType") == "true") {
        var $form = $("select[name $='_creditcards_newcreditcard_type']").closest(".payment-fields");
        var $formRowList = $form.find(".form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard");
            $formRowList.addClass("hide");
            $formRowList.find("input,select").addClass("hide");
            $form.find('.form-row.owner,.form-row.month,.form-row.year').removeClass('required');
            $form.find('.form-row.owner input,.form-row.month select,.form-row.year select').removeClass('required');
            $form.find('.form-row.creditcardnumber input').attr('maxlength','16');
            if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked')){
        		$('.couponsection').find('.couponcontent').addClass('deferactive');
        		if ($('.couponsection').find('.couponcontent').is(':visible')){
        			$('.couponsection').find('.couponcontent').css('display','flex');
        		}
        	}
    } else {
        var $form = $("select[name $='_creditcards_newcreditcard_type']").closest(".payment-fields");
        $form.find('.form-row.owner,.form-row.month,.form-row.year').addClass('required');
        $form.find('.form-row.owner input,.form-row.month select,.form-row.year select').addClass('required');
        $form.find('.form-row.creditcardnumber input').attr('maxlength','19');
        if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val() =="true"){
    		$('.couponsection').find('.couponcontent').removeClass('deferactive');
    		$('.differed-billing-content').addClass('hide');
    		var $deferCheckbox= $('.differedBilling input[type="checkbox"]');
            $deferCheckbox.val(false);
    		$deferCheckbox.prop('checked',false);
    		if ($('.couponsection').find('.couponcontent').is(':visible')){
    			$('.couponsection').find('.couponcontent').css('display','block');
    		}
    	}
    }

    $('form[name="payment-remove"]').on('click', function (e) {

        e.preventDefault();
        var removeCardId=$(this).closest('.cardinfo').find('.creditcardnumber').val();
        // override form submission in order to prevent refresh issues
        var button = $(this).find('.delete');
        $('<input/>').attr({
            type: 'hidden',
            name: button.attr('name'),
            value: button.attr('value') || 'delete card'
        }).appendTo($(this));
        //var data = $(this).serialize();
        var form = new FormData(this);
        var deleteURL = $(this).attr('action');
        dialog.open({
            url: Urls.deleteCreditCardOverLay+'?cardnumber='+removeCardId,
            options: {
                dialogClass: "delete-payment-card",
                width: "638px",
                title: "Delete Confirmation",
                open: function () {
                    $('.cancle-delete-creditcard , .ui-widget-overlay, .delete-payment-card .ui-dialog-titlebar-close').on('click keypress',function(e){
                        if(e.type === "keypress" && e.which != 13 ){
                            return; 
                         }
                        e.preventDefault();
                		dialog.close();
                		if(window.lastClickOrKey === 'key'){
                            button.focus().addClass('focus-outline');
                		}
                    });
                    if(window.lastClickOrKey === 'key'){
                    	util.trapFocus($('.delete-payment-card'), () => {                        
                        	button.focus().addClass('focus-outline');
                        });
                         
                    }
                    $('.confirm-delete-creditcard').on('click',function(e){
                        e.preventDefault();
                        ajax.fetchData({
                            method: 'POST',
                            url: deleteURL,
                            data: form,
                            callback: function () {
                                         page.redirect(Urls.paymentsList);
                                    }
                        })
                    });
                    /* PXSFCC-4495_WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                    
                    if(window.lastClickOrKey === 'key'){
                        setTimeout(function(){
                            $(".ui-dialog").find(".ui-dialog-titlebar-close").focus().addClass('focus-outline');
                        }, 500);
                    }
                }
            }
        });

    });
    $("body").on("change",".makedefault-payment",function(){
        $(this).closest(".payment-default-status").find(".makedefault-button").trigger('click');
    });

}

$("body").on("change",".birthMonth select",function(){
    birthMonthOptional();
});

$(window).load(function(){
    birthMonthOptional();
    initializePaymentForm();
});

function birthMonthOptional() {
	var bm = $('.birthMonth select').val();
	if (bm == '') {
		$('.form-row.birthMonth').addClass('optional');
	}
	else {
		$('.form-row.birthMonth').removeClass('optional');
	}
	if ($('.login-account .username input[type="text"]').val()) {
		if ($('.login-account .username input[type="text"]').val().length > 0) {
	        $('.login-account .username label').addClass('input-focus');
	        if($('.login-account .password input[type="password"]').val() == ''){
	        	$('.login-account .password').addClass('empty-pass');
	        }
	    }
	}
}


function emailSubsServiceFailure(event_name, eventElement){
    //close unsub modal
    if($('.email-unsubscription-section').is(':visible')) {
        $('.email-unsubscription-section').find('.ui-dialog-titlebar-close').trigger('click');
    }
    //remove error
    $(eventElement).parents('.subscribed-status').siblings('#guest-emailid-error').remove();

    //display serice failure message
    var errorElement = "<span id='guest-emailid-error' class='error'>" + Resources.EMAIL_SUBSCRIPTION_FAILED + "</span>";
    if(eventElement.prop('nodeName').toLowerCase() === "button"){
        $(errorElement).insertAfter(eventElement.parents('.subscribe-action'));
    }else{
        $(errorElement).insertAfter(eventElement.parents('.subscribed-status'));
    }

    //reset slider to prevouse selection
    if(eventElement !== null && eventElement.prop('nodeName').toLowerCase() === 'input'){
        if(event_name === 'email_optout') {
            eventElement.prop( "checked", true ).val('subscribed');
            eventElement.parents('.custom-slider-checkbox').find('.slider-label').html('Subscribed');
        }else{
            eventElement.prop( "checked", false ).val('subscribe');
            eventElement.parents('.custom-slider-checkbox').find('.slider-label').html('Subscribe');
        }
    }

    //hide progress
    progress.hide();
}

function emailSubsServiceSuccess(event_name, eventElement, fewerContactsRequested, showThankYouMessage){
    //create tealium object
    var obj = { event_name:event_name, deal_opt_in_out_location: "Email Preferences" };

    //trigger tealium event
    tealium.triggerEvent(obj);

    //close unsub modal
    if($('.email-unsubscription-section').is(':visible')) {
        $('.email-unsubscription-section').find('.ui-dialog-titlebar-close').trigger('click');
    }

    //by default hide coupon
    $('.email-thankyou').hide();
    $('.email-header').show();
    //set slider to correct selection
    if(eventElement !== null && eventElement.prop('nodeName').toLowerCase() === 'input'){
        if(event_name === 'email_optout' && !fewerContactsRequested) {
            eventElement.prop( "checked", false ).val('subscribe');
            eventElement.parents('.custom-slider-checkbox').find('.slider-label').html('Subscribe');
            eventElement.closest('.subscribed-status').find('.fewer-radio-class').hide();
            eventElement.parents('.custom-slider-checkbox').attr('aria-checked','false');
        }else if(event_name === 'email_optout' && fewerContactsRequested) {
            eventElement.prop( "checked", true ).val('subscribed');
            eventElement.parents('.custom-slider-checkbox').find('.slider-label').html('Subscribed');
            eventElement.closest('.subscribed-status').find('.fewer-radio-class').show();
        } else{
            eventElement.prop( "checked", true ).val('subscribed');
            eventElement.parents('.custom-slider-checkbox').find('.slider-label').html('Subscribed');
            eventElement.parents('.custom-slider-checkbox').attr('aria-checked','true');
        }
    }else if(eventElement.prop('nodeName').toLowerCase() === "button"){
        //this is case for subscribing for current brand using button
        //display slider and hide button
        $('.currentsite-brand .custom-slider-checkbox').removeClass("hide");
        $('.currentsite-brand .preference-options').hide();
        if(showThankYouMessage){
            $('.email-preferences').addClass('thankyoumsg-main');
            $('.email-thankyou').show();
            $('.email-header').hide();
        }
    }

    $(".event-msg").remove();
    eventElement.closest(".subscribed-status").append('<div class="event-msg">'+ Resources.SUBSCRIPTION_UPDATE_MSG +'</div>');

    if ($(window).width() < 768) {
        if(eventElement.closest(".subscribed-status").length > 0){
            $('html, body').animate({
                'scrollTop' : eventElement.closest(".subscribed-status").offset().top-100
            });    
        }	    
    }

    //hide progress
    progress.hide();
}

function initializePaymentForm() {

	var $form = $("select[name $='_creditcards_newcreditcard_type']").closest(".payment-fields");
    $form.find('.form-row.owner,.form-row.month,.form-row.year').addClass('required');
    $form.find('.form-row.owner input,.form-row.month select,.form-row.year select').addClass('required');

    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });
}

function initializeEmailPreferences() {
    $("body").on("click",".edit-click",function(e){
		if (!($(this).hasClass('navigate-profile'))) {
	        $(this).closest('.interest').hide();
	        $(".preference-options").removeClass('hide');
    	}
	});
    $("body").on("click",".emailsubscribe-cancelupdate",function(e){
        if($('.iterest-data').length>0){
            $(this).closest('form').find(".interest").show();
            $(".preference-options").addClass('hide');
        }
    });
    $("body").on("change",".unsubscribe-email-radio",function(e){
        $('.select-unsubscribe-reason').show();
        $('.fewercontactsrequested-action').hide();
		$('.reason-notselected').addClass('hide');
    });
    $("body").on("change",".fewercontactsrequested-radio",function(e){
        $('.select-unsubscribe-reason').hide();
        $('.fewercontactsrequested-action').show();
    });
    $("body").on("change","#enableOtherTextbox",function(e){
        $("#changeDescription").prop("disabled",false);
    });
    $("body").on("change",".reasoncode",function(e){
        $("#changeDescription").prop("disabled",true);
        $("#changeDescription").val("");
    });
    $("body").off('keyup','.email-box.guest-emailpreferences').on('keyup','.email-box.guest-emailpreferences', function (e) {
    	e.preventDefault();
    	if (e.which === 13) {
 		   $('button[name="emailsubscribeguest-unsubscribe"]').click();
        }
    });
    
    //Prevent body scroll on click of spacebar
    $("body").off('keydown','.custom-slider-checkbox').on('keydown','.custom-slider-checkbox', function (e) {    	
    	if(e.which == 32){
    		e.preventDefault();
    		return;
    	}
    });
    
    
    //triggering toggle on custom-slider-checkbox focus event on click of spacebar
    $("body").off('keyup','.custom-slider-checkbox').on('keyup','.custom-slider-checkbox', function (e) {
    	e.preventDefault();
    	if (e.which === 32) {
 		   $(this).find('input[name="subscribed-status"]').click();
        }
    });
    
    $("body").on('click', 'button[name="emailsubscribe"],input[name="subscribed-status"]', function (e) {
        var $sliderEvent = $(this);
        var emailPreferenceJSON = getSetEmailPreferenceJSON($sliderEvent);
        var salesChannel = emailPreferenceJSON["salesChannel"];
        var reloadAfterUpdate = $sliderEvent.closest('form').find('input[name=useCachedPreferences]').val() == "false";

        if($sliderEvent.is("button")==false && $sliderEvent.val()=="subscribed"){
            var emailFrequencyModalURL = util.appendParamToURL(Urls.emailFrequencyModal, 'emailid',emailPreferenceJSON["email"]);
            var queryString = util.getQueryStringParams(window.location.search.substr(1));
            emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL,'saleschannel',salesChannel);
            if (typeof queryString !== 'undefined' && typeof queryString.affiliate_id !== 'undefined') {
                emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL, 'affiliate_id', queryString.affiliate_id);
            }
            if (typeof queryString !== 'undefined' && typeof queryString.mid !== 'undefined') {
                emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL, 'mid', queryString.mid);
            }
            $('.subscribed-status.'+salesChannel).find('input[type="checkbox"]').prop( "checked", true );
            dialog.open({
                url: emailFrequencyModalURL,
                options: {
                    dialogClass: "email-unsubscription-section",
                    width: "639px",
                    title: "",
                    open: function () {
                          $sliderEvent.addClass('open-modal-button');
                        $('button[name="emailsubscribe-overlay-submit"]').on('click',function(e){
                            e.preventDefault();
                            var data = $('.emailfrequencyform').serialize();
                            var url = Urls.updateSubscription+"?"+data;
                            url = util.appendParamToURL(url, 'emailPreferences', JSON.stringify(emailPreferenceJSON));
                            url = util.appendParamToURL(url, 'format', 'ajax');
                            $.ajax({
                                url: url,
                                success: function (response) {
                                    if(response.ServiceResponseStatus){
                                        emailSubsServiceSuccess('email_optout', $sliderEvent, response.FewerContactsRequested, response.ShowThankYouMessage);
                                      $('.open-modal-button').closest('.custom-slider-checkbox').focus();
                                      $('.open-modal-button').removeClass('open-modal-button');
                                      if(!response.FewerContactsRequested){
                                       	$sliderEvent.closest('.custom-slider-checkbox').find('.round').removeAttr('aria-label');
                                    }
                                    }else{
                                        //handle failure
                                         emailSubsServiceFailure('email_optout', $sliderEvent);
                                    }
                                },
                                failure: function () {
                                    //handle failure
                                    emailSubsServiceFailure('email_optout', $sliderEvent);
                                }
                            });
                        });

                        //closing on overlay click
                        $('.ui-widget-overlay').on('click',function(e){
                            if($('.email-unsubscription-section').is(':visible')) {
                              $('.email-unsubscription-section').find('.ui-dialog-titlebar-close').trigger('click');
                                 $('.open-modal-button').closest('.custom-slider-checkbox').focus();
                                 $('.open-modal-button').removeClass('open-modal-button');
                            }
                        });
                        /* PXSFCC-4495_WCAG_Modal_focus_management */
                    	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    		$(this).focus();
                        });
                        $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                    }
                }
            });
        }else{
            progress.show($(".primary-content .email-preferences"));
            var url = util.appendParamToURL(Urls.updateSubscription, 'emailPreferences', JSON.stringify(emailPreferenceJSON));
            url = util.appendParamToURL(url, 'format', 'ajax');
            $.ajax({
                url: url,
                success: function (response) {
                    if(response.ServiceResponseStatus){
                        emailSubsServiceSuccess('email_registration', $sliderEvent, response.FewerContactsRequested, response.ShowThankYouMessage)
                        $sliderEvent.closest('.custom-slider-checkbox').find('.round').attr('aria-label',Resources.WCAG_ARIALABEL_DIALOG);
                    }else{
                        emailSubsServiceFailure('email_registration', $sliderEvent);
                    }
                },
                failure: function () {
                    //handle failure
                    emailSubsServiceFailure('email_registration', $sliderEvent);
                }
            })
        }
    });

    $("body").on('click', '#fewer-contact', function (e) {
        var $sliderEvent = $(this);
        var emailPreferenceJSON = getSetEmailPreferenceJSON($sliderEvent);
        emailPreferenceJSON.fewerContactsRequested = false;
        emailPreferenceJSON.subscriptionStatus = 'OptedIn';
        var url = util.appendParamToURL(Urls.updateSubscription, 'emailPreferences', JSON.stringify(emailPreferenceJSON));
            url = util.appendParamToURL(url, 'format', 'ajax');
        $.ajax({
            url: url,
            success: function (response) {
                if(response.ServiceResponseStatus){
                    emailSubsServiceSuccess('email_registration', $sliderEvent, response.FewerContactsRequested, response.ShowThankYouMessage);
                    $sliderEvent.closest('.fewer-radio-class').hide();
                    $sliderEvent.closest('.email-preference-row').next('.email-preference-row').find('.custom-slider-checkbox').focus();
                    if($sliderEvent.closest('.email-preference-row').hasClass('currentsite-brand')){
                        $sliderEvent.closest('.email-preference-row').siblings('.sisterbrands').find('.email-preference-row').first().find('.custom-slider-checkbox').focus();
                    }
                }else{
                    emailSubsServiceFailure('email_registration', $sliderEvent);
                }
            },
            failure: function () {
                //handle failure
                emailSubsServiceFailure('email_registration', $sliderEvent);
            }
        });
    });

    $("body").on('click', 'button[name="emailsubscribeguest"]', function (e) {
    	e.preventDefault();
        $('#guest-emailid-error').remove();
        var form = $(this).closest('form');
        if (!$(form).valid()) {
            return false;
        }
        var emailid = $(this).closest('.subscribe-emailid').find("input[name*='dwfrm_emailpreferences_email']").val();

        var requestEmailPreferenceObj = new Object();
        requestEmailPreferenceObj['email']= emailid;
        requestEmailPreferenceObj['salesChannel']= $(this).closest('.subscribe-emailid').find("input[name='salesChannel']").val();
        requestEmailPreferenceObj['fewerContactsRequested']= false;
        requestEmailPreferenceObj['subscriptionChangeReason']= null;
        requestEmailPreferenceObj['subscriptionStatus']= "OptedIn";
        requestEmailPreferenceObj['subscriptionStatusSetter']= "OptedIn";
        var interests = [];
        $(this).closest('form').find('.input-checkbox:checked').each(function(index,value){
            interests.push($(value).val());
        });
        requestEmailPreferenceObj['interests']= interests;
        requestEmailPreferenceObj['subscriptionChangeDescription']= $(this).closest('form').find("input[name='signupSource']").val() || 'email_acquisition_landing_page';
        var requestEmailPreference = JSON.stringify(requestEmailPreferenceObj);
        progress.show($(".emailsubscription-guest"));
        var URL = util.appendParamToURL(Urls.updateSubscription, 'emailPreferences', requestEmailPreference);
        URL = util.appendParamToURL(URL, 'format', 'ajax');
        URL = util.appendParamToURL(URL, 'guestPrefSubmit', 'true');
        $.ajax({
            url: URL,
            success: function (response) {
                if($(response).find('.subscriptionstatus').val() == "false" || $(response).filter('.subscriptionstatus').val() == "false"){
                    $("<span id='guest-emailid-error' class='error'>"+Resources.EMAIL_SUBSCRIPTION_FAILED+"</span>").insertAfter('.email-box');
                    progress.hide();
                    return false;
                } else {
                	var obj = {
                        event_name:"email_registration",
                        deal_opt_in_out_location: "Email Preferences"
                    };
                    tealium.triggerEvent(obj);
                    $('.primary-content').html(response);
                    progress.hide();
                }
                if($(window).width() < 767) {
                    var viewMoreChar = 250;
                    util.veiwmorelesswithellipse(viewMoreChar);
                }
            }
        })
    });
    $("body").on('click','button[name="emailsubscribeguest-emailmarketing"]',function(e){
        var form=$(this).closest('form');
        var errorMsgValue = $('.email-preferences').find('span.error');
        if(!errorMsgValue.hasClass('hide')){
        	errorMsgValue.addClass('hide');
        }
        form.validate();
        if (!form.valid()) {
        	errorMsgValue.removeClass('hide');
            return false;
        }
        form.submit();
    });
    // SM-995, SM-956 and SM-957
    $("#emailpreference-formsubmit").on('submit',function(e){
    	e.preventDefault();
    	var form=$(this);
        form.validate();
        if (!form.valid()) {
            return false;
        }
        var email = form.find(".form-row.email input").val();
        var salesChannel = form.find(".saleschannel").val();
        var queryString = util.getQueryStringParams(window.location.search.substr(1));
        var signupSource = (typeof window.location.pathname !== 'undefined' && window.location.pathname === "/email-unsubscribe") ? 'unsubscribe_page' : 'my_account_preferences';
        var emailFrequencyModalURL = util.appendParamToURL(Urls.emailFrequencyModal, 'emailid',email);
        emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL,'saleschannel',salesChannel);
        emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL, 'signupSource', signupSource);
        if (typeof queryString !== 'undefined' && typeof queryString.affiliate_id !== 'undefined') {
            emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL, 'affiliate_id', queryString.affiliate_id);
        }
        if (typeof queryString !== 'undefined' && typeof queryString.mid !== 'undefined') {
            emailFrequencyModalURL = util.appendParamToURL(emailFrequencyModalURL, 'mid', queryString.mid);
        }
        dialog.open({
            url: emailFrequencyModalURL,
            options: {
                dialogClass: "email-unsubscription-section",
                width: "639px",
                title: "",
                open: function () {
                    $('button[name="emailsubscribe-overlay-submit"]').on('click',function(e){
                        e.preventDefault();
                    	var data = $('.emailfrequencyform').serialize();
                        var url = Urls.guestEmailUnsubscrbe+"?"+data;
                        url = util.appendParamToURL(url, 'format', 'ajax');
                        ajax.fetchData({
                            url: url,
                            callback: function (response) {
                                $('.unsubscribe-confirmation-email>.left-padding').html('').html(response);
                                var optInOutLocation = "Email Preferences";
                                if (typeof window.location.pathname != 'undefined' && window.location.pathname === "/email-unsubscribe") {
                                    optInOutLocation = "Unsubscribe Page";
                                }
								var obj = {
                                    event_name:"email_optout",
                                    deal_opt_in_out_location: optInOutLocation
								};
								tealium.triggerEvent(obj);

                                if($('.email-unsubscription-section').is(':visible')) {
                               	 $('.email-unsubscription-section').find('.ui-dialog-titlebar-close').trigger('click');
                                }
                            }
                        })
                    });

                    //closing on overlay click
                    $('.ui-widget-overlay').on('click',function(e){
                        if($('.email-unsubscription-section').is(':visible')) {
                            $('.email-unsubscription-section').find('.ui-dialog-titlebar-close').trigger('click');
                        }
                    });
                    /* PXSFCC-4495_WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                		$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                }
            }
        });
    });
}

/**
 * @function getSetEmailPreferenceJSON
 * @description This helps in creating a JSON object on the basis of the data available
 * and are related to the event being triggered for email preference functionality.
 */
function getSetEmailPreferenceJSON( sliderButton ) {
	var emailPreferenceJSON = {}, saleschannel = "", subscriptionStatus = "", emailId = "";
    if(sliderButton.closest('form').length>0){
        saleschannel = sliderButton.closest('form').find(".subscribed-status").find(".saleschannel").val();
        emailId = sliderButton.closest('form').find(".subscribed-status").find(".brandemail").val();
        subscriptionStatus=sliderButton.closest('form').find('input[name="subscribed-status"]').val();
        if (subscriptionStatus == null) {
            subscriptionStatus = sliderButton.val();
        }
    }else{
        saleschannel = sliderButton.closest(".subscribed-status").find(".saleschannel").val();
        emailId = sliderButton.closest(".subscribed-status").find(".brandemail").val();
        subscriptionStatus = sliderButton.val();
    }
    emailPreferenceJSON["email"] = emailId;
    emailPreferenceJSON["salesChannel"] = saleschannel;
    emailPreferenceJSON["fewerContactsRequested"] = false;
    emailPreferenceJSON["otherReasonMessage"] = '';
    var interests = [];
    if(sliderButton.is("button") || subscriptionStatus=="subscribe"){
    	sliderButton.closest("form").find(".preference-options .input-checkbox").each(function(index,value){
            if($(value).prop("checked")){
                interests.push($(value).val());
            }
        });
    }
    emailPreferenceJSON["interests"] = interests;
    emailPreferenceJSON["subscriptionChangeReason"]= null;
    emailPreferenceJSON["subscriptionChangeDescription"] = 'my_account_preferences';

    if(sliderButton.is("button")==false && subscriptionStatus =='subscribed'){
        emailPreferenceJSON["subscriptionStatus"]= "OptedOut";
    }else{
        emailPreferenceJSON["subscriptionStatus"]= "OptedIn";
    }
    return emailPreferenceJSON;
}


if ($(window).width() <= 767){
    $('.create-login').find('.col-2:parent').each(function () {
        $(this).insertBefore($(this).closest('.create-login').find('.check-order'));
    });
}

util.createAccount();

/**
 * @function initializeChangeEmailConfirmation
 * @description Adds an additional level of validation to the RegistrationForm that performs client-side
 * validation on the e-mail and e-mail confirmation field values (if the e-mails do not
 * match, an error is thrown and the form is not submitted).
 */
function initializeChangeEmailConfirmation() {
    // Initialize local variables
    var $registrationContainer;
    var $firstNameContainer;
    var $lastNameContainer;
    var $passwordContainer;
    var $passwordConfirmContainer;
    var $currentEmailContainer;
    var $confirmEmailContainer;
    var $currentEmailField;
    var $confirmEmailField;
    var $confirmEmailError;
    var currentEmailValue;
    var confirmEmailValue;
    var confirmEmailLabel;
    var errorSpanHTML;
    var output;

    // Attach a validation event to the change-password button
    $('#RegistrationForm').on('submit', function () {
        // Create a reference to the current registration form's container
        $registrationContainer = $(this);

        // Create references to the password and e-mail fields
        $firstNameContainer = $registrationContainer.find('div.firstname');
        $lastNameContainer = $registrationContainer.find('div.lastname');
        $passwordContainer = $registrationContainer.find('div.password');
        $passwordConfirmContainer = $registrationContainer.find('div.passwordconfirm');
        $currentEmailContainer = $registrationContainer.find('div.email');
        $confirmEmailContainer = $registrationContainer.find('div.emailconfirm');

        // Exit early if there are existing errors
        if ($firstNameContainer.length > 0 && $firstNameContainer.find('span.error:visible').length > 0) { return false; }
        if ($lastNameContainer.length > 0 && $lastNameContainer.find('span.error:visible').length > 0) { return false; }
        if ($passwordContainer.find('span.error:visible').length > 0) { return false; }
        if ($passwordConfirmContainer.length > 0 && $passwordConfirmContainer.find('span.error:visible').length > 0) { return false; }
        if ($currentEmailContainer.find('span.error:visible').length > 0) { return false; }
        if ($confirmEmailContainer.find('span.error:visible').length > 0) { return false; }

        // Use the containers to find the e-mail address fields
        $currentEmailField = $currentEmailContainer.find('input.input-text');
        $confirmEmailField = $confirmEmailContainer.find('input.input-text');

        // Retrieve the actual e-mail address values
        currentEmailValue = $currentEmailField.val();
        confirmEmailValue = $confirmEmailField.val();

        // Check the e-mail addresses and see if they match
        if (currentEmailValue.toLowerCase() !== confirmEmailValue.toLowerCase()) {
            // If they don't match, prepare the field treatment

            // First, remove any existing server-messages
            $confirmEmailContainer.find('label.server-error').remove();

            // Capture the confirm-email label text (this is the copy we'll use for the error message)
            confirmEmailLabel = window.Resources.INVALID_EMAIL_MATCH;
            errorSpanHTML = '<span class="error">' + confirmEmailLabel + '</span>';

            // Update the field-container to render the error treatment
            $confirmEmailContainer.removeClass('show-text');
            $confirmEmailContainer.addClass('error-handle');

            // Flag the form field to show the error
            $confirmEmailField.addClass('error');
            $confirmEmailField.removeClass('valid');

            // Look for an existing changePassword error-span
            $confirmEmailError = $confirmEmailContainer.find('span.error');

            // Was one found?  If so, use it to capture an error
            if ($confirmEmailError.length > 0) {
                $confirmEmailError.html(confirmEmailLabel);
                $confirmEmailError.show();
            } else {
                // Otherwise, create a new one and seed the error
                $confirmEmailContainer.find('label').prepend(errorSpanHTML);
            }

            // Set the output (an error exists)
            output = false;
        } else {
            // Remove the existing error message
            $confirmEmailContainer.find('span.error').remove();

            // Restore the field properties -- it's valid now
            $confirmEmailField.removeClass('error');
            $confirmEmailField.addClass('valid');

            // Restore the field-container state as well
            $confirmEmailContainer.removeClass('error-handle');
            $confirmEmailContainer.addClass('show-text');

            if ($(this).find('input[name$=_addtoemaillist]').length > 0) {
                // Handle when the customer wants to be added to the email list or not
                // SC-1136: Trigger event for opt in status on click of the place order CTA
                var addToEmailList = $(this).find('input[name$=_addtoemaillist]').is(':checked');
                var obj = {};
                obj.event_name = addToEmailList ? "is_promotable" : "is_not_promotable";
                obj.deal_opt_in_out_location = "Account Sign Up";
                tealium.triggerViewEvent(obj);
            }

            if($(this).find('input[name$=_registertorewards]').length > 0){
                var registerForRewards = $(this).find('input[name$=_registertorewards]').is(':checked');
                var obj = {};
                obj.event_name = registerForRewards ? "rewards_opt_in" : "rewards_opt_out";
                obj.location = "Account Registration";
                tealium.triggerEvent(obj);
            }
            // No errors -- submit the form
            output = true;
        }

        return output;
    });
}

/**
 * @function initializeChangePasswordValidation
 * @description Adds an additional level of validation to the changePasswordForm that performs client-side
 * validation on the new-password to the new-password-confirm field values (if the new passwords do not
 * match, an error is thrown and the form is not submitted).
 */
function initializeChangePasswordValidation() {
    // Initialize local variables
    var $currentPasswordContainer;
    var $newPasswordContainer;
    var $changePasswordContainer;
    var $newPasswordField;
    var $confirmPasswordContainer;
    var $changePasswordField;
    var $changePasswordError;
    var newPasswordValue;
    var changePasswordValue;
    var confirmPasswordLabel;
    var errorSpanHTML;
    var output;

    // Attach a validation event to the change-password button
    $('#ChangePassowrdForm').on('submit', function () {
        // Create a reference to the changing container
        $changePasswordContainer = $('div.change-password');

        // Create references to the password container fields
        $currentPasswordContainer = $changePasswordContainer.find('div.currentpassword');
        $newPasswordContainer = $changePasswordContainer.find('div.newpassword');
        $confirmPasswordContainer = $changePasswordContainer.find('div.newpasswordconfirm');

        // Exit early if there are existing errors
        if ($currentPasswordContainer.find('span.error:visible').length > 0) { return false; }
        if ($newPasswordContainer.find('span.error:visible').length > 0) { return false; }
        if ($confirmPasswordContainer.find('span.error:visible').length > 0) { return false; }

        // Use the containers to find the password fields
        $newPasswordField = $newPasswordContainer.find('input.input-text');
        $changePasswordField = $confirmPasswordContainer.find('input.input-text');

        // Retrieve the actual password values
        newPasswordValue = $newPasswordField.val();
        changePasswordValue = $changePasswordField.val();

        // Check the new passwords and see if they match
        if (newPasswordValue !== changePasswordValue) {
            // If they don't match, prepare the field treatment

            // First, remove any existing server-messages
            $confirmPasswordContainer.find('label.server-error').remove();

            // Capture the confirm-password label text (this is the copy we'll use for the error message)
            confirmPasswordLabel = window.Resources.INVALID_PASSWORD_MATCH;
            errorSpanHTML = '<span class="error">' + confirmPasswordLabel + '</span>';

            // Update the field-container to render the error treatment
            $confirmPasswordContainer.removeClass('show-text');
            $confirmPasswordContainer.addClass('error-handle');

            // Flag the form field to show the error
            $changePasswordField.addClass('error');
            $changePasswordField.removeClass('valid');

            // Look for an existing changePassword error-span
            $changePasswordError = $confirmPasswordContainer.find('span.error');

            // Was one found?  If so, use it to capture an error
            if ($changePasswordError.length > 0) {
                $changePasswordError.html(confirmPasswordLabel);
                $changePasswordError.show();
            } else {
                // Otherwise, create a new one and seed the error
                $confirmPasswordContainer.find('label').prepend(errorSpanHTML);
            }

            // Set the output (an error exists)
            output = false;
        } else {
            // Remove the existing error message
            $confirmPasswordContainer.find('span.error').remove();

            // Restore the field properties -- it's valid now
            $changePasswordField.removeClass('error');
            $changePasswordField.addClass('valid');

            // Restore the field-container state as well
            $confirmPasswordContainer.removeClass('error-handle');
            $confirmPasswordContainer.addClass('show-text');

            // No errors -- submit the form
            output = true;
        }
        return output;
    });
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    util.secondaryNavigationActiveInactiveStates('secondary-navigation-links');
    fillRewardGraphs();
    toggleFullOrder();
    initAddressEvents();
    initPaymentEvents();
    util.createAccount();
    login.init();
    initializeEmailPreferences();
	util.getCityStateOptions();

    if( $(".addresses-list").length > 0 ) {
        $(".delete-controls").on("click"," .cancel", function(){
            $(this).closest(".delete-content").slideUp();
        }).on('keyup','.cancel', function(e){
            if(e.keyCode === 13){
                e.preventDefault();
                $(this).closest('.address-tile').find('button.address-delete').focus().addClass('focus-outline');
            }
        });
    }

    if ($('.error-form.ordererror').length > 0) {
        $('.orderNumber input').focus();
    }

    if ($('#RegistrationForm .form-row.error').length > 0) {
        $('html, body').animate({
            'scrollTop' : $('#RegistrationForm .form-row.error').position().top
        });
        $('#RegistrationForm .form-row.error').focus();
    }


    if($("select[name $='_paymentinstruments_creditcards_newcreditcard_type']").find('option:selected').attr("plccType") == "true") {
        var $form = $("select[name $='_paymentinstruments_creditcards_newcreditcard_type']").closest("form");
        var $formRowList = $form.find(".form-row").not(".type, .number, .save-cancel, .makeDefault, .saveCard");
            $formRowList.addClass("hide");
            $formRowList.find("input,select").addClass("hide");
        $form.find('.form-row.creditcardnumber input').attr('maxlength','16');
    }
    if ($('.birth-month').length > 0) {
        var month = $('.birth-month').val();
        $("select[name $='_profile_customer_birthMonth']").val(month).trigger('change');
    }
    $('.birthMonth select').on('change', function(){
        if($(this).val()) {
            if(!$(this).closest('.birthMonth').hasClass('show-text'))
                $(this).closest('.birthMonth').addClass('show-text');
        }
        else
            $(this).closest('.birthMonth').removeClass('show-text');
    });

    if( $(".pt_account.profile select[name$='_customer_birthMonth']").val() != ''){
        $(".pt_account.profile select[name$='_customer_birthMonth']").prop('disabled', true);
    }else{
        $(".pt_account.profile select[name$='_customer_birthMonth']").prop('disabled', false);
    }

    $(".plcc-ov-right-slider-section, .rewards-trackers-slider").slick({
      infinite: true,
      dots: true,
      speed: 300,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    if( $(window).width() > 767 ) {
    	imagesLoaded('.plcc-ov-right-slider-section').on('always', function() {
    		$(".rewards-trackers-slider").height($(".plcc-ov-right-slider-section").height());
    	});
    }
    $('.return-list').on('click',function(e){
        var returnList = [];
        var listLength = $('.eligible-item .returns-check:checked').length;
        if (listLength > 0) {
            $('.item-error').text('');
            var isValid = true;
            var returnValues = [];
            var attributes='';
            if($('.eligible-item').find('.custom-cart-qty').hasClass('error')){
                $('.eligible-item').find('.custom-cart-qty').removeClass('error');
            }
            if($('.eligible-item').find('.custom-return-reson').hasClass('error')){
                $('.eligible-item').find('.custom-return-reson').removeClass('error');
            }
            $.each($('.eligible-item .returns-check:checked'), function () {
                var $this = $(this);
                var qty = $this.data('qty');
                var reason = $this.data('reason');
                var returnItem= new Object();
                returnItem.qty = qty;
                returnItem.productid = $this.data('productid');
                returnItem.reason = reason;
                returnList.push(returnItem);
                if (qty == '') {
                    $(this).parents('.eligible-item').find('.custom-cart-qty').addClass('error');
                    isValid = false;
                }
                if (reason == '') {
                    $(this).parents('.eligible-item').find('.custom-return-reson').addClass('error');
                    isValid = false;
                }
                $.each($('.cart-columns').find('.column-combine .selected-option:visible'), function () {
                    var value = $(this).text();
                    if(value == 'Return QTY' || value == 'Select reason '){
                    	if(value == 'Select reason '){
                    		value = value.split('Select')[1];
                    	}
                        if(returnValues.indexOf(value) == -1){
                        	returnValues.push(value);
                        }
                    }
                });
            });
            for(var i=0;i<returnValues.length;i++){
                if(i==0 && returnValues.length>1){
                    attributes +=' ' + returnValues[i] + ' and';
                }else{
                    attributes +=' ' + returnValues[i] + ' ';
                }
            }
            if(attributes !=''){
                $('.item-error').html(Resources.PLEASE_SELECT + attributes);
            }
            if (!isValid) {
                $(this).next('.item-error').text(Resources.RETURN_ERROR);
                e.preventDefault();
                return false;
            }
            $(this).closest('form').find('.returnitems').val(JSON.stringify(returnList));
        } else {
            $('.item-error').text(Resources.RETURN_EMPTY_ERROR);
            e.preventDefault();
            return false;
        }
    });

    if($(window).width() <= 767){
        $('.returns-check').each(function () {
            $(this).insertBefore($(this).closest('.list-tems').find('.item-details .name'));
        });
    }

    $('.reasoninput').on('change',function(e){
        e.preventDefault();
        $(this).parents('.eligible-item').find('.returns-check').data('reason',$(this).val());
    });

    $('.secondary-details .return-submit').on('click',function(e){
        e.preventDefault();
        $('#ReturnsForm .return-list').trigger('click');
//    	var message = $('.item-error').eq(0).text();
//    	if (message != '' && message != undefined && message != null) {
//	    	$('.item-error').text('');
//	    	$(this).next('.item-error').text(message);
//    	}
    });

    $('.secondary-details .return-cancel').on('click',function(e){
        e.preventDefault();
        $('#ReturnsForm .submit-cancel').trigger('click');
    });

    $('body').off('click','a.plcc-tooltip').on('click','a.plcc-tooltip', function(e) {
        e.preventDefault();
        dialog.open({
            url: e.target.href,
            options: {
                dialogClass: 'plcc-tooltip tooltip-dialog',
                width: 400
            }
        });
    });

    var continueFlag = false;
    $('body').off('click','.returns-check').on('click','.returns-check',function() {
    	var $curObj = $(this),
    		$closestParent = $curObj.closest('.eligible-item');
        if ($curObj.is(':checked')) {
            var isHeavy = $curObj.data('isheavy');
            var existItem = $('.heavyitem').val();
            $closestParent.find('.column.col-3').removeClass('hide');
            $closestParent.find('.column.col-4').removeClass('hide');
            //SM-5661 to execute multi heavy items, normal items and allowed only one to select
            if (existItem !='' && existItem != null && existItem != undefined && (isHeavy || isHeavy.toString() != existItem)) {
                $('.heavyitem').val(isHeavy);
                $('.heavyitems').val($curObj.data('productid'));
                returnLabelDialog();

            } else if (existItem =='' || existItem == null || existItem == undefined) {
                $('.heavyitem').val(isHeavy);
                if ($('.heavyitem').val() == 'true') {
                    $('.heavyitems').val($curObj.data('productid'));
                    returnLabelDialog();
                }
            }
        } else {
        	$closestParent.find('.column.col-3').addClass('hide');
        	$closestParent.find('.column.col-4').addClass('hide');
            var selectedVal = $('.eligible-item .returns-check:checked').data('isheavy');
            if (selectedVal == '' || selectedVal == null || selectedVal == undefined) {
                selectedVal = '';
            }
            $('.heavyitem').val(selectedVal);
        }
    });
    function returnLabelDialog() {
    	var returnDlg =  dialog.create({
			target : "#heavy-item-dialog",
	        options:{
	            width: 640,
	            dialogClass : 'return-label-heavy',
	            open: function() {
	            	$('body').off('click','.heavy-continue').on('click','.heavy-continue',function(){
	                	var $curObj = $(this),
	                		$curDialog = $curObj.closest('.ui-dialog');
	            		continueFlag = true;
	            		$('.eligible-item .returns-check:checked').trigger('click');
	                    var latestItem = $('.heavyitems').val();
	                    $('.eligible-item .returns-check[data-productid="'+latestItem+'"]').trigger('click');
	                    $curDialog.find('.ui-dialog-titlebar-close').trigger('click');
	                    continueFlag = false;
	                });

	                $('body').off('click','.heavy-cancel').on('click','.heavy-cancel',function(){
	                	var $curObj = $(this);
	                    var latestItem = $('.heavyitems').val();
	                    $('.eligible-item .returns-check[data-productid="'+latestItem+'"]').trigger('click');
	                    $curObj.closest('.ui-dialog').find('.ui-dialog-titlebar-close').trigger('click');
	                });

                    $('.ui-widget-overlay').bind('click', function(){
                        $('#heavy-item-dialog').dialog('close');
                    });
                    /* PXSFCC-4495_WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");

                },
	            close: function() {
	                if(!continueFlag) {
	                	var latestItem = $('.heavyitems').val();
	                    $('.eligible-item .returns-check[data-productid="'+latestItem+'"]').trigger('click');
	                }
	                $(this).dialog('close');
	            }
	         }
	     });
    	var $dialogContent = $('.return-inner-items .heavy-item-dialog').clone();
		$(returnDlg).children().remove();
		$(returnDlg).addClass('heavy-item-dialog').append($dialogContent.removeClass('hide'));
		returnDlg.dialog("open");
    }

    $('.quantityinput').on('change',function(){
    	$(this).parents('.eligible-item').find('.returns-check').data('qty',$(this).val());
	});

    if($(window).width() < 767){
         var $iphonedevice = navigator.platform.match('iPhone')? true : false;
         if($iphonedevice) {
             var $addbreadcrumbclass = $('.breadcrumb .back-arrow');
             $addbreadcrumbclass.addClass('iphonebackarrow');
         }
    }

    if ($('.selected-year').length >= 1 && $('.selected-year').val() != null && $('.selected-year').val() != undefined && $('.selected-year').val() != '') {
        $('#CreditCardForm .year select').val($('.selected-year').val()).trigger('change');
    }
    $('body').on('click', '[name$="input-radio-name"]', function (e) {
        var form = $(this).closest('form');
        var selectedVal;
        if($('[id$="_stopCatalog"]').prop("checked")){
            selectedVal = "stopCatalog"
        }else if($('[id$="_receiveLessCatalog"]').prop("checked")){
            selectedVal = "receiveLessCatalog";
        }else if($('[id$="_requestCatalog"]').prop("checked")){
            selectedVal = "requestCatalog";
        }else {
            selectedVal = "receiveMoreCatalog";
        }
        form.find('input[name="catalogVal"]').val(selectedVal);
    });

    $('body').on('click', '.sister-request-submit', function (e) {
        if($('input[name$="request-sister-brand"]:checked').length == 0){
            $('.catalog-preference-error').html(Resources.CATALOG_PREF_ERROR).addClass('error');
            return false;
        }
        var form = $(this).closest('form');
        var selectedSisCatlog = [];
        $('input[name$="request-sister-brand"]:checked').each(function() {
            selectedSisCatlog.push($(this).val());
        });

        form.find('input[name="sisterCatalogVal"]').val(selectedSisCatlog);
    });

    $('body').on('blur', '.pt_account.addresses #edit-address-form input', function(){
        appendErrorInLabel(this);
    })
}

function readmore() {
    if ($(window).width() < 768) {
        var showChar, ellipsestext, moretext, content, lesstext, characters, hiddencharacter;
        showChar = 250;  // How many characters are shown by default
        ellipsestext = "...";
        moretext = "Read More";
        lesstext = "Read Less";
        $('.current-brand-description .content-asset').each(function() {
            content = $(this).html();
            if(content.length > showChar) {
                var characters = content.substr(0, showChar);
                var hiddencharacter = content.substr(showChar, content.length - showChar);
                var html = characters + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + hiddencharacter + '</span><a href="javascript:void(0);" class="morelink">' + moretext + '</a></span>';
                $(this).html(html);
            }
       });

        $("body").off('click','.morelink').on('click','.morelink',function(e){
            e.preventDefault();
            var $curObj = $(this);
            if($curObj.hasClass("less")) {
              $curObj.removeClass("less");
              $curObj.closest(".content-asset").find('.morecontent span, .moreellipses').toggle();
              $curObj.html(moretext);
            } else {
              $curObj.addClass("less");
              $curObj.closest(".content-asset").find('.morecontent span, .moreellipses').toggle();
              $curObj.html(lesstext);
            }
        });
    }
}

//function to handle new order lookup user experience
function orderlookup(){

    $( document ).ready(function() {
        if($(".ordererror").length > 0){
            $('.lookUpButton').click();
        }
    });

    $('body').on('click', '.buttonCancel', function(e){
        if($(".ordererror").length > 0){
            $(".ordererror").hide();
        }
        if($( '[id$="_domestic"]' ).length > 0){
            $('[id$="_domestic"]').prop("checked", true);
            setTimeout(function(){
            	$('[id$="_domestic"]').trigger("click");
            }, 500);
        }
        // reset any validation errors, if any
    	$('[id$="_domestic"]').closest("form").validate().resetForm();
    });
    
}

$('body').on('click', '.orderLookupToggle', function (e) {
    e.preventDefault();
    $(".orderLookupDefaultForm").toggle();
    $(".orderLookupNarvar").toggle();
    $(".orderstatusSubhead").toggle();
    $(".orderstatusSubheadIntro").toggle();
    $(".orderHeaderDefault").toggle();
    $(".orderHeader").toggle();
});

function appendErrorInLabel(inputElement){
    var $label = $(inputElement).closest('.form-row').find('label');
    var errorSpanId = '#'+$label.attr('for')+'-error';
    var errorSpanText = $label.find('#'+$label.attr('for')+'-error').html();
    if($label.find(errorSpanId).length && errorSpanText !== $label.find('.label-text').html() && errorSpanText.indexOf('Error:') === -1){
        $label.find(errorSpanId).html('Error: ' + errorSpanText);
    }
}

function initPerksLandingPage(){
    if($("#primary.perks-landing").length){
        $("#primary.perks-landing").find(".modal-footer input[type=checkbox], #termsandcondition").on("change", function(){
            var isChecked = $(this)[0].checked;
            $("#primary.perks-landing").find(".modal-footer input[type=checkbox], #termsandcondition").each(function(){
                $(this)[0].checked = isChecked;
            });
        });
        $("#terms-link").on("click", function(e){
            e.preventDefault();
            $(".modal.terms-conditions").show();
            if(!$(".modal.terms-conditions .modal-body").parent().hasClass("slimScrollDiv")){
                $(".modal.terms-conditions .modal-body").slimScroll({
                    height: 455,
                    railVisible: true,
                    color: "#000",
                    railColor: "#fff",
                    distance: '2px',
                    size: "3px",
                    railOpacity: 1
                });
            }
        });
        $(".modal .close").on("click", function(){
            $(this).closest(".modal").hide();
        });
        $(".modal .modal-dialog").on("click", function(){
            $(this).closest(".modal").hide();
        });
        $(".modal .modal-content").on("click", function(e){
            e.stopPropagation();
        });
        
        var addToCartButton = $(".perks-landing .ca-reward-enroll-cta")[0];
        if(!$(addToCartButton).hasClass("disabled")){
            addToCartButton.disabled = false;
        }
        // Add to Cart
        $("#addToCartPerksForm").on("submit", function(e){
            e.preventDefault();
            $(".perks-landing .error-msg").hide();
            var miniCartQty = $(".shopping-bag-sm .minicart-quantity.total-qty").eq(0).length ===  0 ? 0 : parseInt($(".shopping-bag-sm .minicart-quantity.total-qty").eq(0).text());
            var tcCheckbox = $(this).find("input[type=checkbox]#termsandcondition");
            tcCheckbox.parent().removeClass("tc-wrapper-error");
            if(miniCartQty < 40){
                if(tcCheckbox[0].checked){
                    $(".perks-landing .loader").show();
                    var formJSONData = "{";
                    $(this).find("[name]").each(function(){
                        formJSONData += (formJSONData === '{' ? '"' : ', "') + $(this).attr("name") + '":"' + ($(this).attr("type") === "checkbox" ? $(this)[0].checked  : $(this).val()) + '"';              
                    });
                    formJSONData += "}";
                    formJSONData = JSON.parse(formJSONData);
                    $.post($(this).attr("action")+"&format=ajax", formJSONData, function(data){
                        $(".perks-landing .loader").hide();
                        $(".add-to-cart-overlay-perks").show();
                        $(".add-to-cart-overlay-perks .modal-body").html(data);
                        $(".modal .view-bag").on("click", function(){
                            window.location = "/cart";
                        });        
                        $(".modal .checkout-now").on("click", function(){
                            window.location = "/checkout";
                        });
                        $(".modal .continue-shopping").on("click", function(){
                            $(this).closest(".modal").hide();
                        });
                        var newQuantity = $(data).find('.minicart-quantity').text();
                        if(newQuantity > 0 && $('.ucp2-cart-icon').length){
                            $('.ucp2-cart-icon').toggleClass('ucp2-cart-with-item-icon');
                            $('.ucp2-cart-icon.ucp2-cart-with-item-icon').toggleClass('ucp2-cart-icon');
                            $('.ucp2-cart-with-item-icon').append('<span class="minicart-quantity total-qty">'+newQuantity+'</span>');
                            $('.shopping-bag-sm').attr({"data-overlay-on-hover": 'yes', "data-is-overlay": 'yes','data-overlayname' : "fly-overlay-bag"});
                        }
                        else if(newQuantity > 0 && $('.ucp2-cart-with-item-icon > span.minicart-quantity').length && $('.ucp2-cart-icon > span.minicart-quantity').text() !== newQuantity){
                            $('.ucp2-cart-with-item-icon > span.minicart-quantity').text(newQuantity);
                        }
                        else if(newQuantity == 0 && $('.ucp2-cart-with-item-icon').length){
                            $('.ucp2-cart-with-item-icon').toggleClass('ucp2-cart-icon');
                            $('.ucp2-cart-with-item-icon.ucp2-cart-icon').toggleClass('ucp2-cart-with-item-icon');
                        }
                        minicart.show(data);
                        $(".perks-landing .ca-reward-enroll-cta").addClass("disabled");
                        $(".perks-landing .ca-reward-enroll-cta")[0].disabled = true;
                        $(".perks-landing .ca-reward-enroll-cta").val("ADDED TO YOUR BAG");
                        $(".perks-landing .ca-reward-enroll-cta.disabled + .error-msg").show();
                        
                    });
                }else{
                    tcCheckbox.focus().parent().addClass("tc-wrapper-error");
                }
            }else{
                $(".perks-landing .error-msg.qty").show();
            }
        });
        
        $("#addToCartPerksForm").find("input[type=checkbox]#termsandcondition").on("blur change", function(e){ 
            $(this).parent().removeClass("tc-wrapper-error");
        });
    }
}

var account = {
    init: function () {
        initializeEvents();
        initializeAddressForm();
        initializeChangePasswordValidation();
        initializeChangeEmailConfirmation();
        giftcert.init();
        validator.init();
        readmore();
        internationalshipping.init();
        orderlookup();
        initPerksLandingPage();
    },
    initCartLogin: function () {
        login.init();
    }
};

module.exports = account;
